let iconsModule = null;
let iconsPromise = null;

export function loadTablerIcons() {
  if (iconsModule) return Promise.resolve(iconsModule);
  if (!iconsPromise) {
    iconsPromise = import('tabler-icons-react').then((mod) => {
      iconsModule = mod;
      return mod;
    });
  }
  return iconsPromise;
}

export function getTablerIconSync(name) {
  if (!iconsModule || !name) return null;
  const Icon = iconsModule[name];
  return typeof Icon === 'function' ? Icon : null;
}
